const decodeJWT = (token: any) => {
  // const token = sessionStorage.getItem('token')
  if (token) {
    const base64Url = token?.split('.')[1] // Extract payload
    const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/') // URL-safe base64 fix
    return JSON.parse(atob(base64))
  }
  return null
}

export const saveUserToStorage = (data: any) => {
  if (data?.token?.accessToken) {
    sessionStorage.setItem('token', data?.token?.accessToken)
    localStorage.setItem('token', data?.token?.accessToken)
    const decodedToken = decodeJWT(data?.token?.accessToken)
    const expTime = Math.round(decodedToken.exp)
    sessionStorage.setItem('tokenExp', expTime.toString())
    localStorage.setItem('tokenExp', expTime.toString())
  }
  if (data?.user) {
    sessionStorage.setItem('user', JSON.stringify(data.user))
    localStorage.setItem('user', JSON.stringify(data.user))
  }
}

export const removeUserFromStorage = () => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token')
  const user = sessionStorage.getItem('user') || localStorage.getItem('user')
  const tokenExp = sessionStorage.getItem('tokenExp') || localStorage.getItem('tokenExp')
  if (token) {
    sessionStorage.removeItem('token')
    localStorage.removeItem('token')
  }
  if (tokenExp) {
    sessionStorage.removeItem('tokenExp')
    localStorage.removeItem('tokenExp')
  }
  if (user) {
    sessionStorage.removeItem('user')
    localStorage.removeItem('user')
  }
}
export const checkTokenExpiration = () => {
  const exp = sessionStorage.getItem('tokenExp') || localStorage.getItem('tokenExp')
  if (exp) {
    return Number(exp) < Math.round(Date.now() / 1000)
  }
  return false
}
export const userIsLoggedIn = () => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token')
  return !!token
}
